module.exports = {
    enumTypes: (type) => {
        switch (type) {
            case 'INFO':
                return { allyText: 'Information', status: 'information' };
            case 'SUCCESS':
                return { allyText: 'Confirmation', status: 'confirmation' };
            case 'WARNING':
            case 'ERROR':
            default:
                return { allyText: 'Attention', status: 'attention' };
        }
    }
};
